// @flow
import React from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';

import './CategoryCurrent.scss';

type Props = {
  name: string,
  count: ?number,
};

const CategoryCurrent = ({ name, count }: Props) => {
  return (
    <div className="CategoryCurrent">
      <h2>
        {name}{' '}
        {count && (
          <span className="lighten">({count}개의 상품)</span>
        )}
      </h2>
    </div>
  );
};

export default CategoryCurrent;



// WEBPACK FOOTER //
// ./src/components/categories/CategoryCurrent/CategoryCurrent.js